import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import { TextButton, ConfirmButton, CancelButton } from 'scy/buttons';
import CheckmarkIcon from 'images/icons/controls/check.svg?react-svg';
import CloseIcon from 'images/icons/controls/close.svg?react-svg';
import { textLeft } from 'scy/utils.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import styles from './styles.mod.scss';

export default function DeliveryNotesInput({
  deliveryNotes,
  handleChange,
  handleEditClick
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const textField = useRef();
  const hasDeliveryNotes = deliveryNotes && !!deliveryNotes.length;
  const isActive = isExpanded || !hasDeliveryNotes;

  return (
    <div
      className={classnames(styles.deliveryNotesFormContainer, {
        [styles.deliveryNotesFormContainerActive]: isActive
      })}
    >
      {!isActive ? (
        <TextButton
          noUnderline
          className={classnames(textLeft, flex1)}
          onClick={() => setIsExpanded(true)}
        >
          {deliveryNotes}
        </TextButton>
      ) : (
        <form
          onSubmit={e => {
            e.preventDefault();
            setIsExpanded(false);
          }}
          onKeyDown={e => {
            if (e.key === 'Escape') {
              setIsExpanded(false);
              if (textField.current) textField.current.blur();
            }
          }}
          className={classnames(flex, flex1)}
        >
          <textarea
            placeholder="Add delivery notes?"
            className={classnames(styles.deliveryNotesInput, {
              [styles.deliveryNotesInputExpanded]: isExpanded
            })}
            onFocus={() => setIsExpanded(true)}
            value={deliveryNotes}
            onChange={e => handleChange(e.target.value)}
            ref={textField}
            maxLength="150"
          />

          {isExpanded &&
            (hasDeliveryNotes ? (
              <ConfirmButton
                type="submit"
                className={styles.deliveryNotesButton}
              >
                <CheckmarkIcon />
              </ConfirmButton>
            ) : (
              <CancelButton
                type="submit"
                className={styles.deliveryNotesButton}
              >
                <CloseIcon />
              </CancelButton>
            ))}
        </form>
      )}

      {!isExpanded && (
        <TextButton
          noUnderline
          className={classnames(padding.left_xs, padding.right_xs)}
          onClick={handleEditClick}
        >
          Edit
        </TextButton>
      )}
    </div>
  );
}
